export default "PAC tertiaire BAT-TH-104 — Prime CEE pompe à chaleur | Solution Éco France";
